import { URI } from '@/config/config'

export default async ({ rootState },payload) => {
  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken
    },
  }

  let path = `${URI}park/usage-location`;

  const query = Object.keys(payload)
  .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(payload[k])}`)
  .join('&');

  path += `?${query}`;

  const parksResult = await fetch(path, opts)
  const jsonResult = await parksResult.json()

  if (jsonResult.errors) {
    return Promise.reject(jsonResult.errors)
  }
  
  return jsonResult
}